import React from 'react';

const MaintenancePage = () => {
  return (
    <div
      style={{
        fontFamily: "'Roboto', sans-serif",
        background: "linear-gradient(to bottom, #333, #777)",
        color: "#d3d3d3",
        textAlign: "center",
        margin: 0,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundAttachment: "fixed",
      }}
    >
      <div>
        <h1 style={{ fontSize: "3rem", color: "white" }}>Technical work</h1>
        <img
          src="https://tashkii.qpcore.com/logo192.png"
          alt="Maintenance Logo"
          style={{
            maxWidth: "150px",
            height: "auto",
            margin: "20px 0",
            borderRadius: "10px",
          }}
        />
        <p style={{ fontSize: "1.2rem", margin: "10px" }}>
          The website is down, but the programs are performing their therapeutic functions! We will be back soon.
          <br />
          Thanks for keeping calm.
        </p>
        <p style={{ fontSize: "1rem", margin: "10px", color: "#bdbdbd" }}>
          Instagram:{" "}
          <a
            href="https://tashkii.qpcore.com/go/instagram"
            style={{
              color: "white",
              textDecoration: "underline",
            }}
            onMouseOver={(e) => (e.target.style.textDecoration = "none")}
            onMouseOut={(e) => (e.target.style.textDecoration = "underline")}
          >
            Tashkii
          </a>.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;




